<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 16:59:52
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 00:57:30
-->
<template>
  <div class="zhiya-detail-page page-container">
    <video-player :datas="videoData" :speaker="speaker" :viplock="vip_lock" :allowEvent.sync="playerAllowEvent"
      :collect="miniTabActive[HEART_ID]" @clickCollect="onClickMiniTab(HEART_ID)"></video-player>
    <div class="content">
      <episode-list :title="episodeTitle" :datas="episodeList" v-if="episodeList.length"
        @select="onSelectEpisode"></episode-list>
      <div class="container-wrap">
        <div class="left-bl">
          <comment-list :topic="topic" type="zhiya" :id="episodeId" v-show="!miniTabActive[DOC_ID]"
            @inputFocus="inputFocus"></comment-list>
        </div>
        <div class="right-bl">
          <!-- <mini-tabs :disabled="miniDisabled" @onClickTab="onClickMiniTab" :active="miniTabActive"></mini-tabs> -->
          <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
        </div>
      </div>
    </div>
    <buyvipResultDialog :payresPopup="payresPopup" v-show="payresPopup" :order_num="order_num"
      :order_status="order_status" :buy_type="buy_type" @closeres="closeres"></buyvipResultDialog>

  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import EpisodeList from '@/components/AppEpisodeList';
import RecommendVideos from '@/components/AppRecommendVideos';
// import MiniTabs from '@/components/AppMiniTabs';
import CommentList from '@/components/AppCommentList';
import requestApi from '@/service';
import buyvipResultDialog from '@/components/buy_vipResultDialog.vue';
import { mapState } from 'vuex';
import configFields from '@/utils/configFields';
const { DOC_ID, HEART_ID } = configFields;
export default {
  name: 'ZhiYaDetail',
  components: {
    VideoPlayer,
    EpisodeList,
    RecommendVideos,
    // MiniTabs,
    CommentList,
    buyvipResultDialog,
  },
  data() {
    return {
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      videoData: {},
      speaker: {},
      episodeList: [],
      recommendList: [],
      topic: {},
      comments: [],
      commentsTotal: 2,
      miniDisabled: [],
      episodeTitle: '',
      miniTabActive: {},
      episodeId: null,
      DOC_ID,
      HEART_ID,
      payresPopup: false,
      order_num: '',
      buy_type: '',
      order_status: 1,//订单状态
      vip_lock: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/zhiya/detail') {
        this.init();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if ((from.path === '/' || !from.path) && to.query.id && to.query.order_num && to.query.buy_type) {
      window.$router.replace({
        name: 'SpeechDetail',
        query: { id: to.query.id },
        params: {
          id: to.query.id,
          order_num: to.query.order_num,
          buy_type: to.query.buy_type,
        },
      })
    } else {
      next(vm => {
        if (to.params.id && to.params.order_num && to.params.buy_type) {
          vm.check_order(to.params.order_num, to.params.buy_type);
        }
      })
    }
  },
  computed: {
    ...mapState(['vipInfo']),
  },
  methods: {
    //判断时候支付成功
    check_order(ordernum, buytype) {
      this.order_num = ordernum
      this.buy_type = buytype
      console.log(this.order_num, this.buy_type)
      requestApi('/v3/api/h5/order/wanxiang/',
        {
          order_num: this.order_num,
          is_pc: 1,
          buy_type: this.buy_type,
        },
        'GET').then(res => {
          console.log(res)
          if (res.msg == '等待支付') {

          } else {
            this.order_num = ordernum
            this.buy_type = buytype
            this.order_status = 2
            this.payresPopup = true
          }
        });
    },
    closeres(val) {
      this.payresPopup = false
    },
    init() {
      Object.assign(this.$data, this.$options.data());
      this.zhiyaId = this.$route.query.id || '';
      this.episodeId = this.$route.query.episodeId;
      this.miniDisabled = [DOC_ID];
      this.miniTabActive = {
        [DOC_ID]: false,
        [HEART_ID]: false,
      };
      this.refreshPage();
      this.initScrollTop();
    },
    refreshPage() {
      this.getData();
      this.getRecommend();
    },
    getData() {
      requestApi(`/v3/api/site/zhiya/${this.episodeId}/detail/`).then(({ items, speaker, base }) => {
        const { cover, video_url, title, first_category, date, titlelanguage, is_collect, member_type } = this.getCurEpisode(items);
        if (!this.zhiyaId) {
          this.zhiyaId = base.id;
          this.getRecommend();
        }
        // 使用 map 方法替换 video_url 中的 http:// 为 https://
        const updatedVideoUrls = video_url.map(item => {
          if (item.video_url) {
            item.video_url = item.video_url.replace('http:', 'https:');
          }
          return item;
        });
        this.videoData = {
          cover,
          videoUrls: updatedVideoUrls,
          intro: titlelanguage,
        };
        this.topic = {
          title,
          category: first_category,
          date,
          intro: titlelanguage,
        };
        if (member_type == 2) {
          if (!this.vipInfo) {
            this.vip_lock = true
          }
        }
        this.miniTabActive[HEART_ID] = is_collect;
        this.speaker = speaker;
        this.episodeTitle = this.speaker.name;
        this.episodeList = items;
      });
    },
    getRecommend() {
      if (this.zhiyaId) {
        const url = `/v3/api/site/zhiya/${this.zhiyaId}/recommend/`;
        requestApi(url).then(({ recommended }) => {
          this.recommendList = recommended && recommended.length ? recommended : [];
        });
      }
    },
    /**
     * @description: 获取当前播放集
     */
    getCurEpisode(data = this.episodeList) {
      return data.filter(item => item.is_current)[0];
    },
    onClickMiniTab(id) {
      if (id === HEART_ID) {
        if (this.checkLogin()) {
          this.collect().then(() => {
            this.miniTabActive[id] = !this.miniTabActive[id];
          });
        }
      }
    },
    /**
     * @description: 选分集
     */
    onSelectEpisode(data) {
      this.gotoZhiYaDetail(this.zhiyaId, data.id, 0);
    },
    onClickRecommend(episodeId) {
      this.gotoZhiYaDetail('', episodeId);
    },
    gotoZhiYaDetail(id, episodeId) {
      this.$router.push({
        path: '/zhiya/detail',
        query: {
          id,
          episodeId,
        },
      });
    },
    /**
     * @description: 收藏
     */
    collect() {
      return requestApi(
        '/v3/api/v1/zhiya/collection/change/',
        {
          zhiya_video_id: this.episodeId,
        },
        'POST'
      );
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-actions-bl {
  position: relative;
  width: 100%;
  text-align: center;
}

.content {
  .container-wrap {
    display: flex;
    align-items: flex-start;
    margin: 10px auto 100px;
  }

  .left-bl {
    width: 72%;
    max-width: 827px;
    margin-right: 10px;
    box-sizing: border-box;
    background: $C1;
    padding: 20px;
  }

  .right-bl {
    width: 28%;
    background-color: $C10;
  }
}
</style>
